import React, { PropTypes } from "react";
// import TimePicker from "../../_rc-time-picker-1.1.6";
import Loadable from "../../react-loadable";
import DateTimeFormat from "gregorian-calendar-format";
// import moment from "moment";
import dayjs from "dayjs";
import GregorianCalendar from "../../_gregorian-calendar";
import classNames from "classnames";
import defaultLocale from "./locale/zh_CN";
import WeaLocaleProvider from "../../ecology9/wea-locale-provider";

const getLabel = WeaLocaleProvider.getLabel;
const TimePicker = Loadable({
  loader: () => import("../../_rc-time-picker-1.1.6"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default function wrapPicker(Picker, defaultFormat) {
  return class PickerWrapper extends React.Component {
    static defaultProps = {
      format: defaultFormat || "yyyy-MM-dd",
      transitionName: "slide-up",
      popupStyle: {},
      onChange() {},
      onOk() {},
      toggleOpen() {},
      locale: {},
      align: {
        offset: [0, -9]
      }
    };

    static contextTypes = {
      antLocale: PropTypes.object
    };

    getLocale() {
      const props = this.props;
      let locale = defaultLocale;
      // const context = this.context;
      // if (context.antLocale && context.antLocale.DatePicker) {
      //   locale = context.antLocale.DatePicker;
      // }
      // 统一合并为完整的 Locale
      locale = {
        lang: {
          placeholder: getLabel("27938", "请选择日期"),
          rangePlaceholder: [
            getLabel("24978", "开始日期"),
            getLabel("24980", "结束日期")
          ],
          today: getLabel("15537", "今天"),
          now: getLabel("386451", "此刻"),
          backToToday: getLabel("386452", "返回今天"),
          ok: getLabel("826", "确定"),
          clear: getLabel("311", "清除"),
          month: getLabel("33452", "月"),
          year: getLabel("26577", "年"),
          previousMonth: getLabel("386453", "上个月 (翻页上键)"),
          nextMonth: getLabel("386454", "下个月 (翻页下键)"),
          monthSelect: getLabel("386455", "选择月份"),
          yearSelect: getLabel("386456", "选择年份"),
          decadeSelect: getLabel("386457", "选择年代"),
          yearFormat: getLabel("386607", "yyyy年"),
          monthFormat: getLabel("386608", "M月"),
          dateFormat: getLabel("386609", "yyyy年M月d日"),
          previousYear: getLabel("386458", "上一年 (Control键加左方向键)"),
          nextYear: getLabel("386459", "下一年 (Control键加右方向键)"),
          previousDecade: getLabel("386460", "上一年代"),
          nextDecade: getLabel("386461", "下一年代"),
          previousCentury: getLabel("386462", "上一世纪"),
          nextCentury: getLabel("386463", "下一世纪"),
          format: {
            eras: [getLabel("383357", "公元前"), getLabel("383358", "公元")],
            months: [
              getLabel("1492", "一月"),
              getLabel("1493", "二月"),
              getLabel("1494", "三月"),
              getLabel("1495", "四月"),
              getLabel("1496", "五月"),
              getLabel("1497", "六月"),
              getLabel("1498", "七月"),
              getLabel("1499", "八月"),
              getLabel("1800", "九月"),
              getLabel("1801", "十月"),
              getLabel("1802", "十一月"),
              getLabel("1803", "十二月")
            ],
            shortMonths: [
              getLabel("25825", "1月"),
              getLabel("25826", "2月"),
              getLabel("25827", "3月"),
              getLabel("25828", "4月"),
              getLabel("25829", "5月"),
              getLabel("25830", "6月"),
              getLabel("25831", "7月"),
              getLabel("25832", "8月"),
              getLabel("25833", "9月"),
              getLabel("25834", "10月"),
              getLabel("25835", "11月"),
              getLabel("25836", "12月")
            ],
            weekdays: [
              getLabel("24626", "星期天"),
              getLabel("392", "星期一"),
              getLabel("393", "星期二"),
              getLabel("394", "星期三"),
              getLabel("395", "星期四"),
              getLabel("396", "星期五"),
              getLabel("397", "星期六")
            ],
            shortWeekdays: [
              getLabel("16106", "周日"),
              getLabel("16100", "周一"),
              getLabel("16101", "周二"),
              getLabel("16102", "周三"),
              getLabel("16103", "周四"),
              getLabel("16104", "周五"),
              getLabel("16105", "周六")
            ],
            veryShortWeekdays: [
              getLabel("385820", "日"),
              getLabel("385821", "一"),
              getLabel("385822", "二"),
              getLabel("385823", "三"),
              getLabel("385824", "四"),
              getLabel("385825", "五"),
              getLabel("385826", "六")
            ],
            ampms: [getLabel("16689", "上午"), getLabel("16690", "下午")],
            datePatterns: [
              getLabel("386610", "yyyy年M月d日 EEEE"),
              getLabel("386609", "yyyy年M月d日"),
              "yyyy-M-d",
              "yy-M-d"
            ],
            timePatterns: [
              "ahh'时'mm'分'ss'秒' 'GMT'Z",
              "ahh'时'mm'分'ss'秒'",
              "H:mm:ss",
              "ah:mm"
            ],
            dateTimePattern: "{date} {time}"
          }
        },
        timePickerLocale: {
          clear: getLabel("311", "清除"),
          placeholder: getLabel("386464", "请选择时间"),
          format: {
            eras: [getLabel("383357", "公元前"), getLabel("383358", "公元")],
            months: [
              getLabel("1492", "一月"),
              getLabel("1493", "二月"),
              getLabel("1494", "三月"),
              getLabel("1495", "四月"),
              getLabel("1496", "五月"),
              getLabel("1497", "六月"),
              getLabel("1498", "七月"),
              getLabel("1499", "八月"),
              getLabel("1800", "九月"),
              getLabel("1801", "十月"),
              getLabel("1802", "十一月"),
              getLabel("1803", "十二月")
            ],
            shortMonths: [
              getLabel("25825", "1月"),
              getLabel("25826", "2月"),
              getLabel("25827", "3月"),
              getLabel("25828", "4月"),
              getLabel("25829", "5月"),
              getLabel("25830", "6月"),
              getLabel("25831", "7月"),
              getLabel("25832", "8月"),
              getLabel("25833", "9月"),
              getLabel("25834", "10月"),
              getLabel("25835", "11月"),
              getLabel("25836", "12月")
            ],
            weekdays: [
              getLabel("24626", "星期天"),
              getLabel("392", "星期一"),
              getLabel("393", "星期二"),
              getLabel("394", "星期三"),
              getLabel("395", "星期四"),
              getLabel("396", "星期五"),
              getLabel("397", "星期六")
            ],
            shortWeekdays: [
              getLabel("16106", "周日"),
              getLabel("16100", "周一"),
              getLabel("16101", "周二"),
              getLabel("16102", "周三"),
              getLabel("16103", "周四"),
              getLabel("16104", "周五"),
              getLabel("16105", "周六")
            ],
            veryShortWeekdays: [
              getLabel("385820", "日"),
              getLabel("385821", "一"),
              getLabel("385822", "二"),
              getLabel("385823", "三"),
              getLabel("385824", "四"),
              getLabel("385825", "五"),
              getLabel("385826", "六")
            ],
            ampms: [getLabel("16689", "上午"), getLabel("16690", "下午")],
            datePatterns: [
              getLabel("386610", "yyyy年M月d日 EEEE"),
              getLabel("386609", "yyyy年M月d日"),
              "yyyy-M-d",
              "yy-M-d"
            ],
            timePatterns: [
              "ahh'时'mm'分'ss'秒' 'GMT'Z",
              "ahh'时'mm'分'ss'秒'",
              "H:mm:ss",
              "ah:mm"
            ],
            dateTimePattern: "{date} {time}"
          }
        },
        timezoneOffset: -new Date().getTimezoneOffset(),
        firstDayOfWeek: 7,
        minimalDaysInFirstWeek: 1
      };
      const result = { ...locale, ...props.locale };
      result.lang = { ...locale.lang, ...props.locale.lang };
      return result;
    }

    getFormatter = fmt => {
      const format = fmt || this.props.format;
      const formatter = new DateTimeFormat(
        format,
        this.getLocale().lang.format
      );
      return formatter;
    };

    parseDateFromValue = (value, limit) => {
      if (value) {
        if (typeof value === "string") {
          if (dayjs(value).format() === "Invalid date") {
            return "";
          }
          return this.getFormatter().parse(value, { locale: this.getLocale() });
        } else if (value instanceof Date) {
          let date = new GregorianCalendar(this.getLocale());
          date.setTime(+value);
          date.unlimited = limit;
          return date;
        }
      } else if (limit) {
        let date = new GregorianCalendar(this.getLocale());
        date.setTime(new Date());
        date.unlimited = limit;
        return date;
      }
      return value;
    };

    toggleOpen = ({ open }) => {
      this.props.toggleOpen({ open });
    };

    render() {
      const props = this.props;
      const pickerClass = classNames({
        "ant-calendar-picker": true
      });
      const pickerInputClass = classNames({
        "ant-calendar-range-picker": true,
        "ant-input": true,
        "ant-input-lg": props.size === "large",
        "ant-input-sm": props.size === "small"
      });

      const locale = this.getLocale();

      const timeFormat = props.showTime && props.showTime.format;
      const rcTimePickerProps = {
        formatter: new DateTimeFormat(
          timeFormat || "HH:mm",
          locale.timePickerLocale.format
        ),
        showSecond: timeFormat && timeFormat.indexOf("ss") >= 0,
        showHour: timeFormat && timeFormat.indexOf("HH") >= 0,
        needSecond: props.needSecond
      };
      const timePicker = props.showTime ? (
        <TimePicker
          {...rcTimePickerProps}
          {...props.showTime}
          prefixCls="ant-time-picker"
          placeholder={locale.timePickerLocale.placeholder}
          locale={locale.timePickerLocale}
          transitionName="slide-up"
        />
      ) : null;

      return (
        <Picker
          {...props}
          pickerClass={pickerClass}
          pickerInputClass={pickerInputClass}
          locale={locale}
          timePicker={timePicker}
          toggleOpen={this.toggleOpen}
          getFormatter={this.getFormatter}
          parseDateFromValue={this.parseDateFromValue}
        />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./_antd1.11.2/date-picker/wrapPicker.jsx